import * as React from "react";
import { actionCreators as uiActionCreators } from "ui/store";
import { actionCreators } from "page/calendar/store";
import { CalendarState } from "burde";
import { RouteComponentProps, withRouter } from "react-router";
import ControlsContainer from "../controls-container";
import { NavigationComponent } from "ui/constants";
import { useResources } from "contexts/resource-context";
import { useExtraPages } from "hooks/use-extra-pages";
import MonthDividerSelector from "../month-divider-selector/month-divider-selector";

type Props = {
    calendar: CalendarState;
    activeComponent: NavigationComponent;
} & typeof actionCreators &
    typeof uiActionCreators;

const MonthDivider = ({
    calendar,
    activeComponent,
}: Props & RouteComponentProps) => {
    const resources = useResources();
    const { monthDividers, numberOfPagesLeft } = useExtraPages(calendar);

    return (
        <ControlsContainer Title={activeComponent.resourceKey}>
            <p>{resources["MonthDivider_Description"]}</p>
            <MonthDividerSelector
                calendar={calendar}
                monthDividerResources={monthDividers}
                numberOfPagesLeft={numberOfPagesLeft}
            />
        </ControlsContainer>
    );
};

const RoutedMonthDivider = withRouter(MonthDivider);
export { RoutedMonthDivider as MonthDivider };
